"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeSentryErrorLogger = exports.SentryErrorLogger = exports.Environment = void 0;
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const integrations_1 = require("@sentry/integrations");
var Environment;
(function (Environment) {
    Environment["dev"] = "development";
    Environment["test"] = "test";
    Environment["prod"] = "production";
})(Environment = exports.Environment || (exports.Environment = {}));
;
const SentryErrorLogger = (options) => {
    const initialize = () => {
        Sentry.init(options);
    };
    const setUserProperty = (propertyName, value) => {
        if (propertyName === "email" && typeof value === "string") {
            Sentry.setUser({ email: value });
        }
    };
    const logError = (error, extraData) => {
        let normalizedError = new Error(error.message);
        normalizedError.name = error.name;
        normalizedError.stack = error.stack;
        Sentry.withScope((scope) => {
            if (typeof extraData !== "undefined") {
                scope.setExtras(extraData);
            }
            Sentry.captureException(normalizedError);
        });
    };
    const logMessage = (message) => {
        Sentry.captureMessage(message, "log");
    };
    const addBreadcrumb = (category, message) => {
        Sentry.addBreadcrumb({
            category: category,
            message: message,
            level: "log",
        });
    };
    return {
        initialize,
        logError,
        logMessage,
        setUserProperty,
        addBreadcrumb,
    };
};
exports.SentryErrorLogger = SentryErrorLogger;
const ComposeSentryErrorLogger = (props) => {
    const { dsn, environment, releaseVersion, httpClientOptions } = props;
    return (0, exports.SentryErrorLogger)({
        dsn: dsn,
        integrations: [
            new tracing_1.BrowserTracing({
                tracePropagationTargets: ["localhost", /^\//],
            }),
            new integrations_1.HttpClient(httpClientOptions),
        ],
        sendDefaultPii: true,
        tracesSampleRate: 0.1,
        environment: environment,
        release: releaseVersion,
    });
};
exports.ComposeSentryErrorLogger = ComposeSentryErrorLogger;
